module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("Mr Wrong")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summer Picnic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pont Du Gard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whip Hand")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Proposition")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Devoted")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Child’s Play")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toutes Directions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three Miles Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-texts"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0